// src/locales/en/stockTransfer.js
export const stockTransfer = {
  // Page titles
  allStockTransfers: 'Warehouse Transfers',
  createStockTransfer: 'New Transfer',
  editStockTransfer: 'Edit Transfer',
  pageDescription: 'Move stock between your warehouses',
  detailsDescription: 'Stock transfer note',
  stockTransferNote: 'STOCK TRANSFER NOTE',
  backToTransfers: 'Back to Transfers',

  // Fields
  transferNumber: 'Transfer No',
  transferDate: 'Transfer Date',
  warehouse: 'Warehouse',
  warehouses: 'Warehouses',
  fromWarehouse: 'From Warehouse',
  toWarehouse: 'To Warehouse',
  selectWarehouse: 'Select warehouse',
  notes: 'Notes',
  notesPlaceholder: 'Reason or notes for this transfer (optional)',
  status: 'Status',
  statusDraft: 'Draft',
  statusCompleted: 'Completed',
  totalItems: 'Total Items',
  totalQuantity: 'Total Qty',
  createdBy: 'Created By',
  completedBy: 'Completed By',
  completedAt: 'Completed At',
  dateRange: 'Date Range',
  allWarehouses: 'All Warehouses',
  allStatuses: 'All Statuses',
  searchPlaceholder: 'Search by transfer number...',

  // Items
  items: 'Items',
  itemsLabel: 'items',
  product: 'Product',
  sku: 'SKU',
  quantity: 'Qty',
  fromStock: 'Stock at Source',
  inStock: 'In stock',
  actions: 'Actions',
  add: 'Add',
  removeItem: 'Remove item',
  searchProductsPlaceholder: 'Search products by name, SKU or barcode...',
  selectFromWarehouseFirst: 'Select the From warehouse first',
  searchingProducts: 'Searching...',
  noProductsFound: 'No products found',
  noItemsAdded: 'No items added',
  addItemsHint: 'Search a product, enter the quantity and press Enter',


  // Actions
  saveDraft: 'Save Draft',
  saveAndComplete: 'Save & Complete',
  complete: 'Complete Transfer',
  printNote: 'Print Note',

  // Dialogs
  confirmCompleteTitle: 'Complete Transfer?',
  confirmCompleteMessage: 'Stock will be deducted from the source warehouse and added to the destination warehouse. This cannot be undone.',
  confirmDelete: 'Delete this draft transfer?',
  confirmChangeFrom: 'Changing the source warehouse will clear the added items. Continue?',

  // Validation
  fromWarehouseRequired: 'From warehouse is required',
  toWarehouseRequired: 'To warehouse is required',
  sameWarehouseError: 'From and To warehouses must be different',
  itemsRequired: 'Add at least one item',
  invalidQuantity: 'All quantities must be greater than zero',

  // Messages
  draftSaved: 'Transfer saved as draft',
  transferCompleted: 'Transfer completed and stock updated',
  transferDeleted: 'Transfer deleted',
  noTransfersFound: 'No transfers match your filters',
  noTransfersYet: 'No warehouse transfers yet',
  failedToLoad: 'Failed to load transfer',
  failedToLoadTransfers: 'Failed to load transfers',
  failedToSave: 'Failed to save transfer',
  failedToComplete: 'Failed to complete transfer',
  failedToDelete: 'Failed to delete transfer',
  computerGeneratedNote: 'This is a computer-generated stock transfer note.',
};
